module.exports = __webpack_public_path__ + "img/mononoke.a5ccc73b.webp";